import type { OrgFieldsValues } from 'components/Form/Fields/Org/getOrgFields';
import type { I18nFn } from 'i18n/types/I18nFn';
import { ApiOrgType } from 'modules/listing/orgs/api/types/ApiOrgType';

import { getOrgDetailFields } from './getOrgDetailFields';

export function getStaffFields(
  i18n: I18nFn,
  values: OrgFieldsValues,
  isInUS: boolean,
) {
  return [
    {
      title: i18n('Basic Info'),
      sections: [
        {
          rows: [
            {
              fields: ['name'],
            },
            {
              fields: ['logo'],
            },
          ],
        },
      ],
    },
    {
      title: 'Organization Type',
      sections: [
        {
          rows: [
            ...(isInUS
              ? [
                  {
                    fields: ['is501c3'],
                  },
                ]
              : []),
            ...(values.is501c3 === false || !isInUS
              ? [
                  {
                    fields: ['orgType'],
                  },
                ]
              : []),
          ],
        },
      ],
    },
    {
      title: i18n('Organization Details'),
      sections: [
        {
          rows: [
            {
              fields: ['locale'],
            },
            {
              fields: ['vatNumber'],
            },
            {
              fields: ['linkedinName'],
            },
            {
              fields: ['linkedinId'],
            },
            {
              fields: ['governmentId'],
            },
            ...getOrgDetailFields({
              orgType: values.orgType,
            }),
          ],
        },
      ],
    },
    {
      title: i18n('Additional Details'),
      sections: [
        {
          rows: [
            ...(values.orgType === ApiOrgType.NONPROFIT
              ? [
                  {
                    fields: ['mission'],
                  },
                ]
              : []),
            {
              fields: ['description'],
            },
            ...(values.orgType === ApiOrgType.CORPORATION
              ? []
              : [
                  {
                    fields: ['areasOfFocus'],
                  },
                ]),
          ],
        },
      ],
    },
    ...(['NONPROFIT', 'GOVERNMENT'].includes(values.orgType)
      ? [
          {
            title: i18n('Accept Donations'),
            sections: [
              {
                rows: [
                  {
                    fields: ['donationLink'],
                  },
                ],
              },
            ],
          },
        ]
      : []),
    {
      title: i18n('Contact'),
      sections: [
        {
          rows: [
            {
              fields: ['links'],
            },
            {
              fields: ['email'],
            },
            {
              fields: ['phone'],
            },
          ],
        },
      ],
    },
    {
      title: i18n('Location'),
      sections: [
        {
          rows: [
            {
              fields: ['locationType'],
            },
            {
              fields: ['address'],
            },
          ],
        },
      ],
    },
    ...(values.orgType !== ApiOrgType.CORPORATION
      ? [
          {
            title: i18n('Media Gallery'),
            sections: [
              {
                rows: [
                  {
                    fields: ['banner'],
                  },
                  {
                    fields: ['slideshowItems'],
                  },
                ],
              },
            ],
          },
        ]
      : []),
  ];
}
